const STUDIO_IMG = "/assets/sheed-studio.jpg";
const MIC_IMG =
  "https://images.unsplash.com/photo-1587478041427-1a75b9af94f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxzdHVkaW8lbWljcm9waG9uZSUyMHZpbnRhZ2V8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc4MDUwOTY3fDA&ixlib=rb-4.1.0&q=85";
const MIC2_IMG =
  "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxzdHVkaW8lMjBtaWNyb3Bob25lJTIwdmludGFnZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzgwNTA5Njd8MA&ixlib=rb-4.1.0&q=85";

const GEAR = [
  "Various Microphones",
  "96k Sample Rate Conversion",
  "MTM Studio Monitoring",
  "Hardware Channel Strips",
  "Various Analog Outboard Gear",
];

export const Gear = () => {
  return (
    <section
      id="studio"
      data-testid="studio-section"
      className="relative bg-white border-t-2 border-black"
    >
      <div className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
        <div className="mb-14">
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-black/60 mb-4">
            [ 004 / The Room ]
          </p>
          <h2 className="font-display uppercase leading-[0.85] tracking-tighter text-5xl sm:text-6xl md:text-7xl">
            Our Gear
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-0 border-2 border-black">
          {/* Big image */}
          <div className="md:col-span-7 relative aspect-[4/3] md:aspect-auto md:min-h-[520px] border-b-2 md:border-b-0 md:border-r-2 border-black overflow-hidden">
            <img
              src={STUDIO_IMG}
              alt="Studio console"
              className="w-full h-full object-cover grayscale"
            />
            <div className="absolute bottom-5 left-5 bg-white px-3 py-2 border-2 border-black font-mono text-[10px] tracking-[0.25em] uppercase">
              LIVE ROOM · 01
            </div>
          </div>

          {/* Intro text */}
          <div className="md:col-span-5 p-8 md:p-10 flex flex-col justify-between">
            <div>
              <h3 className="font-display text-3xl md:text-4xl uppercase tracking-tighter leading-none">
                Engineering<br />You Can Trust
              </h3>
              <p className="mt-6 text-black/75 leading-relaxed">
                Finding the right engineer is everything. Our team takes pride
                in never being stuck in old, traditional ways - technology has
                moved leaps beyond the 90s, and we move with it. We lead with
                modern tools, push what today's equipment can do, and build
                legacies on records that sound unmistakably of-the-moment.
              </p>
            </div>
            <p className="mt-10 font-mono text-[11px] tracking-[0.25em] uppercase text-black/60">
              4030 Wake Forest Rd · Ste 349 · Raleigh, NC
            </p>
          </div>

          {/* Gear list */}
          <div className="md:col-span-5 p-8 md:p-10 border-t-2 md:border-t-2 md:border-r-2 border-black bg-[hsl(0,0%,97%)]">
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-black/60 mb-6">
              Featured Equipment
            </p>
            <ul className="divide-y divide-black/15">
              {GEAR.map((g, i) => (
                <li
                  key={g}
                  data-testid={`gear-item-${i}`}
                  className="flex items-center justify-between py-4"
                >
                  <span className="font-display text-xl md:text-2xl uppercase tracking-tight">
                    {g}
                  </span>
                  <span className="font-mono text-[11px] tracking-[0.25em] text-black/50">
                    {(i + 1).toString().padStart(2, "0")}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Two stacked photos */}
          <div className="md:col-span-7 grid grid-cols-2 border-t-2 border-black">
            <div className="aspect-square border-r-2 border-black overflow-hidden">
              <img
                src={MIC_IMG}
                alt="Microphone"
                className="w-full h-full object-cover grayscale hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="aspect-square overflow-hidden">
              <img
                src={MIC2_IMG}
                alt="Microphone"
                className="w-full h-full object-cover grayscale hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gear;
